export default "__VITE_ASSET__DA5W81XQ__"